//@ts-nocheck
import http from 'http';
import https from 'https';
import { HttpLink } from '@apollo/client';
import whereami from '../../../utils/whereami';
export default (function (config) {
    var _a;
    // TODO: check running context and get proper config
    // const configEnvs = whereami.isClientSide ? useClientEnv().client : useServerEnv().server;
    var protocol = ((_a = config === null || config === void 0 ? void 0 : config.host) === null || _a === void 0 ? void 0 : _a.startsWith('https')) ? https : http;
    var uri = "".concat(config === null || config === void 0 ? void 0 : config.host, "/graphql");
    var httpLink = new HttpLink({
        fetch: fetch,
        uri: uri,
        fetchOptions: whereami.isServerSide
            ? {
                agent: new protocol.Agent({
                    keepAlive: config === null || config === void 0 ? void 0 : config.keepAlive,
                }),
            }
            : {},
    });
    return httpLink;
});
//# sourceMappingURL=createHttpLink.js.map